import { getFileName } from '../utils/FileNameUtils';
import { openFileInApp } from '../utils/openPdfInApp';

function FileUploadField({
  name,
  label,
  onChange,
  selectedFile = null,
  existingFilePath = '',
  existingFileBaseUrl = '',
  showClear = false,
  clearFieldName,
  clearChecked = false,
  onClearChange,
  isMarkedClear = false,
  labelClassName = 'form-group col-sm-4 text-right',
  wrapperClassName = 'col-sm-7',
  accept,
  emptyMessage = 'No file uploaded',
  trailingBreak = true,
}) {
  const inputId = `${name}_upload`;
  const selectedFileName = selectedFile?.name || null;
  const existingFileName = existingFilePath ? getFileName(existingFilePath) : null;
  const displayName = isMarkedClear ? null : (selectedFileName || existingFileName);
  const hasFile = Boolean(displayName);
  const existingFileUrl = existingFilePath && existingFileBaseUrl
    ? `${existingFileBaseUrl}${existingFilePath}`
    : null;
  const clearStatusMessage = isMarkedClear
    ? (existingFilePath ? 'Marked for removal on update' : emptyMessage)
    : null;
  const canPreview = hasFile && !clearStatusMessage && (selectedFile || existingFileUrl);

  const handlePreviewClick = (event) => {
    event.preventDefault();
    if (selectedFile) {
      openFileInApp(selectedFile, {
        title: displayName,
        fileName: displayName,
        downloadFileName: displayName,
      });
      return;
    }
    if (existingFileUrl) {
      openFileInApp(existingFileUrl, {
        title: displayName,
        fileName: displayName,
        downloadFileName: displayName,
      });
    }
  };

  return (
    <>
      <label htmlFor={inputId} className={labelClassName}>{label}</label>
      <div className={`${wrapperClassName} file-upload-row`}>
        <div className="file-upload-field file-upload-grow">
          <input
            type="file"
            id={inputId}
            name={name}
            onChange={onChange}
            className="file-upload-input"
            accept={accept}
          />
          <label htmlFor={inputId} className="file-upload-btn">Choose File</label>
          <span className={`file-upload-status ${hasFile ? 'has-file' : ''}`}>
            {clearStatusMessage || (
              canPreview ? (
                <button
                  type="button"
                  className="file-upload-preview-link"
                  onClick={handlePreviewClick}
                  title={`Preview ${displayName}`}
                >
                  {displayName}
                </button>
              ) : (
                displayName || emptyMessage
              )
            )}
          </span>
        </div>
        {showClear ? (
          <div className="file-upload-clear">
            <input
              type="checkbox"
              id={clearFieldName}
              name={clearFieldName}
              checked={clearChecked || false}
              onChange={onClearChange}
            />
            <label htmlFor={clearFieldName}>Clear</label>
          </div>
        ) : null}
      </div>
      {trailingBreak ? <br /> : null}
    </>
  );
}

export default FileUploadField;
